export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4723.ec7277cc.jpg";